import Connectors from "../../../jsx/components/Dashboard/Connectors/Connectors";

const ConnectorsWrapper = () => {
  return <Connectors />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(ConnectorsWrapper);
